import { render, staticRenderFns } from "./ChatWithMe.vue?vue&type=template&id=8cf219da&"
import script from "./ChatWithMe.vue?vue&type=script&lang=js&"
export * from "./ChatWithMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports